import { useClassNames } from '@magnetic/hooks';
import { Popover } from '@magnetic/popover';
import React, { forwardRef } from 'react';
import './styles.css.js';

const Tooltip = forwardRef(
  ({ analytics, className, ...props }, ref) => /* @__PURE__ */ React.createElement(Popover, {
    className: useClassNames("mds-tooltip-rebuild", className),
    ...props,
    ...analytics ? { analytics: { ...analytics, component: "tooltip" } } : {},
    ref
  })
);

export { Tooltip };
//# sourceMappingURL=index.js.map
